module.exports = __webpack_public_path__ + "img/16581247_S.c16f4d05.png";